export enum SearchSectionId {
  Benefits = 'benefits',
  Guides = 'guides',
  HelpfulResponse = 'helpful-response',
}
